import Popup from '@components/popup';
import css from './index.module.css';
import { toast } from 'sonner';
import axios from 'axios';
import { useState, useEffect } from 'react';
import useUserData from '@hooks/useUserData';

function AddPopupProduct ({ product, showPopup, setShowPopup }: { product: any, showPopup: boolean, setShowPopup: any }) {
    const token = localStorage.getItem('authToken');
    const [unit, setUnit] = useState<'КГ' | 'ШТ'>(() => {
        if (product?.unit === 'КГ') return 'КГ';
        return 'ШТ';
    });
    const [count, setCount] = useState<number>(() => {
        if (product?.unit === 'КГ') return 0;
        return 0;
    });
    const [countInput, setCountInput] = useState<string>('');
    const { refreshCartData } = useUserData();

    useEffect(() => {
        if (showPopup && product) {
            if (product?.unit === 'КГ') {
                setUnit('КГ');
            } else {
                setUnit('ШТ');
            }
        }
    }, [product?.id, showPopup]);

    useEffect(() => {
      if (showPopup) {
        setCountInput('');
        setCount(0);
      }
    }, [showPopup]);

    useEffect(() => {
      if (showPopup) {
        setCountInput('');
        setCount(0);
      }
    }, [unit, showPopup]);

    const handleCountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setCountInput(value);
      
      if (value === '' || value === '.') {
        return;
      }
      
      const numValue = parseFloat(value);
      if (isNaN(numValue)) return;

      if (unit === 'ШТ') {
        const intValue = Math.floor(numValue);
        setCount(intValue);
      } else if (unit === 'КГ') {
        setCount(numValue);
      }
    };

    const handleCountBlur = () => {
      if (countInput === '' || countInput === '.') {
        const minValue = unit === 'ШТ' ? 1 : 0.1;
        setCount(minValue);
        setCountInput(minValue.toString());
        return;
      }
      
      const numValue = parseFloat(countInput);
      if (isNaN(numValue)) {
        const minValue = unit === 'ШТ' ? 1 : 0.1;
        setCount(minValue);
        setCountInput(minValue.toString());
        return;
      }

      if (unit === 'ШТ') {
        const intValue = Math.max(1, Math.floor(numValue));
        setCount(intValue);
        setCountInput(intValue.toString());
      } else if (unit === 'КГ') {
        const kgValue = Math.max(0.1, numValue);
        setCount(kgValue);
        setCountInput(kgValue.toString());
      }
    };

    const adjustCount = (delta: number) => {
      const currentValue = count || (unit === 'ШТ' ? 0 : 0);
      if (unit === 'ШТ') {
        const newValue = Math.max(1, currentValue + delta);
        const intValue = Math.floor(newValue);
        setCount(intValue);
        setCountInput(intValue.toString());
      } else if (unit === 'КГ') {
        const newValue = Math.max(0.1, currentValue + delta);
        const roundedValue = Math.round(newValue * 10) / 10;
        setCount(roundedValue);
        setCountInput(roundedValue.toString());
      }
    };

    const addToCart = () => {
      const finalCount = count || (unit === 'ШТ' ? 1 : 0.1);
      
      if (unit === 'ШТ' && (finalCount < 1 || !Number.isInteger(finalCount))) {
          toast.error('Для штук введите целое число от 1');
          return;
      }
      if (unit === 'КГ' && finalCount < 0.1) {
          toast.error('Для килограмм введите значение от 0.1');
          return;
      }
      const data = {
        prodID: product.id,
        unit,
        count: finalCount
      }
  
      axios.post(`${import.meta.env.VITE_API_URL}/user/cart`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }).then(() => {
        setShowPopup(false);
        toast.success('Товар добавлен в корзину');
        refreshCartData();
      }).catch(() => {
        toast.error('Возникла ошибка, не смогли добавить товар');
      });
    };
    
    return (
      <Popup showPopup={showPopup} setShowPopup={setShowPopup}>
        <div className={css.addPopup}>
          <h1>Добавить в корзину</h1>
          <label>Количество товара</label>
          {unit === 'КГ' ? (
            <>
              <div className={css.countControls}>
                <button
                  type="button"
                  className={css.countButton}
                  onClick={() => adjustCount(-0.1)}
                  disabled={(count || 0.1) <= 0.1}
                >
                  −
                </button>
                <input 
                  type="text"
                  inputMode="decimal"
                  placeholder="Количество (кг)"
                  value={countInput}
                  onChange={handleCountChange}
                  onBlur={handleCountBlur}
                  className={css.countInput}
                />
                <button
                  type="button"
                  className={css.countButton}
                  onClick={() => adjustCount(0.1)}
                >
                  +
                </button>
              </div>
            </>
          ) : (
            <div className={css.countControls}>
              <button
                type="button"
                className={css.countButton}
                onClick={() => adjustCount(-1)}
                disabled={(count || 1) <= 1}
              >
                −
              </button>
              <input 
                type="text"
                inputMode="numeric"
                placeholder="Количество (шт)"
                value={countInput}
                onChange={handleCountChange}
                onBlur={handleCountBlur}
                className={css.countInput}
              />
              <button
                type="button"
                className={css.countButton}
                onClick={() => adjustCount(1)}
              >
                +
              </button>
            </div>
          )}

          <button className={css.submit} onClick={addToCart}>Добавить в корзину</button>
        </div>
      </Popup>
    );
}

export default AddPopupProduct;